import { ChatResponse } from '../types';
import { mockAutoragFunction } from './mockAutorag';

// Direct call to autorag without using a worker
export const sendChatMessage = async (message: string): Promise<ChatResponse> => {
  try {
    console.log('Sending message directly to autorag:', message);
    
    // For local development, use the mock implementation
    if (process.env.NODE_ENV === 'development') {
      console.log('Using mock autorag implementation for local development');
      const mockResponse = await mockAutoragFunction(message);
      
      return {
        success: true,
        response: mockResponse,
        timestamp: new Date().toISOString()
      };
    }
    
    // In production, use the Cloudflare Pages Function
    const response = await fetch('/api/autorag', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: message }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Received response from autorag:', data);
    
    return {
      success: true,
      response: data,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error sending message to autorag:', error);
    return {
      success: false,
      response: null,
      timestamp: new Date().toISOString(),
      error: error instanceof Error ? error.message : 'Unknown error occurred'
    };
  }
};
